var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      staticClass: "badge badge-large badge-purple mb-1 mr-1 cursor-pointer",
      on: { click: _vm.onClick },
    },
    [_vm._v("\n    " + _vm._s(_vm.value.value) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }